import { Redirect } from "react-router-dom"
import React from 'react'

const RedirectToReceipt=()=>(
    <Redirect to="/receipt" />
)

export default RedirectToReceipt


// WEBPACK FOOTER //
// ./src/routes/redirectToReceipt.js